import repository from '../../repositories/financial/billing.repository';

const findByRequestId = async (requestId) =>
    repository.findByRequestId(requestId)
        .then(res => res.data);

export default {
    findByRequestId
}